<template>
  <v-row v-masonry="masonryId">
    <v-col
      v-masonry-tile="masonryId"
      cols="12"
      sm="6"
      lg="4"
      v-if="show_past_action_items"
    >
      <past-action-item-talking-point></past-action-item-talking-point>
    </v-col>
    <v-col
      v-masonry-tile="masonryId"
      cols="12"
      sm="6"
      lg="4"
      v-if="show_recognitions"
    >
      <recognition-talking-point></recognition-talking-point>
    </v-col>
    <v-col
      v-masonry-tile="masonryId"
      cols="12"
      sm="6"
      lg="4"
      v-for="(point, i) in sorted_talkingPoints"
      :key="i"
    >
      <talking-point
        :talkingPoint="point"
        v-on:redraw="redrawMasonry"
      ></talking-point>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import TalkingPoint from "@/components/checkin/TalkingPoint";
import PastActionItemTalkingPoint from "@/components/checkin/PastActionItemTalkingPoint";
import RecognitionTalkingPoint from "@/components/checkin/RecognitionTalkingPoint";
export default {
  name: "TalkingPoints",
  components: {
    TalkingPoint,
    PastActionItemTalkingPoint,
    RecognitionTalkingPoint
  },
  data: () => ({ masonryId: "talking-points-masonry-grid" }),
  computed: {
    show_past_action_items() {
      return this.checkin.pastActionItems.length > 0;
    },
    show_recognitions() {
      return this.checkin.recognitions.length > 0;
    },
    sorted_talkingPoints() {
      let list = this._.orderBy(
        this.checkin.talkingPoints.filter(x => !x.snoozed),
        ["completeDate", "isUrgent"],
        ["desc", "desc"]
      );

      return list;
    },
    ...mapGetters({ checkin: "checkin/checkin" })
  },
  methods: {
    redrawMasonry() {
      let self = this;
      setTimeout(function() {
        self.$redrawVueMasonry(self.masonryId);
      }, 200);
    }
  }
};
</script>
